<template>
  <div class="page-content pdf-film-fee-balance">
    <h1 class="page-title">{{ $locale("sideMenu.reports.AccountsReceivableVerify") }}</h1>
    <!-- Search Area -->
    <el-form
      ref="form"
      class="search-area"
      :model="formData"
      label-position="top"
    >
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            prop="monthDate"
            required
            :label="$locale('pdfFilmFeeBalance.month')"
            :show-message="false"
          >
            <div class="datepicker">
              <el-button class="egl-btn-yellow" @click="getCurMonth(-1)">
                <i class="el-icon-arrow-left"></i>
              </el-button>
              <el-date-picker
                class="month-input"
                type="month"
                v-model="formData.monthDate"
                format="yyyy-MM"
                value-format="timestamp"
                :clearable="false"
                :picker-options="pickerOptions"
                @change="getCurMonth(0)"
              ></el-date-picker>
              <el-button class="egl-btn-yellow" @click="getCurMonth(1)">
                <i class="el-icon-arrow-right"></i>
              </el-button>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            prop="cinemaIds"
            required
            :label="$locale('pdfFilmFeeBalance.cinemasName')"
            :show-message="false"
          >
            <el-select
              v-model="formData.cinemaId"
              :placeholder="$locale('pdfFilmFeeBalance.placeholder')"
            >
              <el-option
                v-for="item in cinemaList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-button class="download egl-btn-yellow" @click="downloadPdf" :disabled="btnDisabled">{{$locale('global.download')}}</el-button>
        </el-col>
      </el-row>
    </el-form>
    <div class="table-module info-supplement-container"></div>
    <pdf-viewer
      ref="report"
      :filename="$locale('sideMenu.reports.AccountsReceivableVerify')"
    >
      <AccountsReceivableVerifyPdf :pdfData="pdfData" @printPDF="printPDF"></AccountsReceivableVerifyPdf>
    </pdf-viewer>
  </div>
</template>

<script>
import PdfViewer from "@/components/Report/PdfPreview.vue";
import { getCinemaList } from "@/helpers/service/api/common.js";
import { getAccountsReceivableVerifyService } from "@/helpers/service/api/pdfAccountsReceivableVerify.js";
import AccountsReceivableVerifyPdf from "@/components/PdfAccountsReceivableVerify/Pdf/AccountsReceivableVerifyPdf.vue";

export default {
  name: "accountsReceivableVerify",
  components: {
    PdfViewer,
    AccountsReceivableVerifyPdf,
  },
  data() {
    return {
      onSearch: {
        selectMonth: this.$moment().startOf("month").valueOf(),
        cinemaId: "",
      },
      formData: {
        monthDate: this.$moment().startOf("month").valueOf(),
        cinemaId: ""
      },
      pickerOptions: {
        disabledDate: this.disableMonth,
      },
      cinemaList: [],
      pdfData: {},
    };
  },
  computed: {
    btnDisabled() {
      let result = false;
      result = Object.values(this.formData).findIndex(_val => !_val) > -1;
      return result;
    }
  },
  created() {
    this.getCinemaData();
  },
  methods: {
    getCurMonth(num = 0) {
      const currentMonth = this.$moment().startOf("month").valueOf();
      const updatedMonth = num === 0 ? this.$moment(this.formData.monthDate).valueOf() : this.$moment(this.formData.monthDate).subtract(-(num), "months").valueOf();

      this.formData.monthDate = updatedMonth > currentMonth ? currentMonth : updatedMonth;
    },
    async downloadPdf() {
      const _monthDate = this.$moment(this.formData.monthDate).startOf("month").format("YYYY-MM-DD");
      getAccountsReceivableVerifyService({ ...this.formData, monthDate: _monthDate }).then(res => {
        if(res.success) {
          this.pdfData = res.data;
          // this.$refs.report.generateReport();
        }
      });
    },
    getCinemaData() {
      getCinemaList().then(res => {
        this.cinemaList = res.data.data;
      });
    },
    printPDF() {
      this.$refs.report.generateReport();
    },
  },
};
</script>
<style scoped lang="less">
.pdf-film-fee-balance {
  position: relative;
  overflow: hidden;

  .pdf-viewer {
    position: absolute;
    z-index: -1;
  }

  .search-area {
    .datepicker {
      display: flex;

      .el-input {
        padding: 0 10px;
      }
    }

    .download {
      margin-top: 42px;
    }
  }
}
</style>
